// extracted by mini-css-extract-plugin
module.exports = {"background":"LandingPage_background__3GF3U","titulo":"LandingPage_titulo__16tlX","button":"LandingPage_button__3SFnT"};